import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import MyButton from "../../util/MyButton";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import LikeButton from "./LikeButton";
import Comments from "./Comments";
import CommentForm from "./CommentForm";
import Media from "react-media";

//MUI stuff
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Avatar from "@material-ui/core/Avatar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

//Icons
import CloseIcon from "@material-ui/icons/Close";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";

import { IoIosHeartEmpty, IoIosRocket, IoIosTrash } from "react-icons/io";

//Redux Stuff
import { connect } from "react-redux";
import { getPost, clearErrors } from "../../redux/actions/dataActions";

const styles = {
  spinnerDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

const PostDialog = (props) => {
  const {
    classes,
    openDialog,
    post: {
      body,
      createdAt,
      comments,
      likeCount,
      commentCount,
      userImage,
      username,
    },
    UI: { loading },
  } = props;

  const dialogMarkup = loading ? (
    <div className={classes.spinnerDiv}>
      <CircularProgress size={30} thickness={4} />
    </div>
  ) : (
    <div class="post">
      {/* <ListItemAvatar style={{ display: "flex" }}>
        <Avatar
          src={userImage}
          alt="Profile"
          style={{ marginRight: "0.3rem" }}
        />
        <Typography
          component={Link}
          color="primary"
          variant="h5"
          to={`/users/${username}`}
        >
          @{username}
        </Typography>
      </ListItemAvatar>
      <ListItemText
        fullWidth
        secondary={
          <React.Fragment>
            <Typography variant="body1" style={{ color: "#5b7083" }}>
              {dayjs(createdAt).format("h:mma, MMMM DD YYYY")}
            </Typography>
            <Typography variant="p" style={{ color: "#0f1419" }}>
              {body}
            </Typography>
            <Typography variant="body1">
              <LikeButton postId={props.postId} />
              <span>{likeCount} Likes</span>
              <MyButton tip="comments">
                <ChatBubbleOutlineIcon color="textSecondary" />
              </MyButton>
              <span>{commentCount} Comments</span>
            </Typography>
          </React.Fragment>
        }
      /> */}
      <div
        class="name"
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          marginBottom: "0.5rem",
        }}
      >
        <Avatar
          src={userImage}
          alt="Profile"
          style={{ marginRight: "0.3rem" }}
        />
        <Typography
          component={Link}
          color="primary"
          variant="h5"
          to={`/users/${username}`}
          style={{ marginRight: "0.3rem" }}
        >
          @{username}
        </Typography>
        <Typography variant="body1" style={{ color: "#5b7083" }}>
          {dayjs(createdAt).format("h:mma, MMMM DD YYYY")}
        </Typography>
      </div>
      <div className="more">
        <React.Fragment>
          <Typography className="textfield" variant="p">
            {body}
          </Typography>
          <Divider variant="fullWidth" />
          <Typography variant="body1">
            <LikeButton postId={props.postId} />
            <span>
              {likeCount} {`${likeCount}` > 1 ? "Likes" : "Like"}
            </span>
            <MyButton tip="comments">
              <ChatBubbleOutlineIcon color="textSecondary" />
            </MyButton>
            <span>
              {commentCount} {`${commentCount}` > 1 ? "Comments" : "Comment"}
            </span>
          </Typography>
          <Divider variant="fullWidth" />
        </React.Fragment>
      </div>
      <CommentForm postId={props.postId} />
      <Comments comments={comments} />
    </div>
  );

  const [open, setOpen] = useState(false);
  const [oldPathState, setOldPath] = useState("");
  const [newPathState, setNewPath] = useState("");

  const handleOpen = () => {
    let oldPath = window.location.pathname;
    const newPath = `/users/${props.username}/post/${props.postId}`;

    if (oldPath === newPath) oldPath = `/users/${props.username}`;

    window.history.pushState(null, null, newPath);

    setOpen(true);
    setOldPath(oldPath);
    setNewPath(newPath);
    props.getPost(props.postId);
  };

  const handleClose = () => {
    window.history.pushState(null, null, oldPathState);
    setOpen(false);
    props.clearErrors();
  };

  useEffect(() => {
    if (openDialog) {
      handleOpen();
    }
  }, []);

  return (
    <Fragment>
      <MyButton onClick={handleOpen} tip="Comments">
        <ChatBubbleOutlineIcon color="textSecondary" />
      </MyButton>
      <Media
        queries={{
          small: "(max-width: 768px)",
        }}
      >
        {(matches) =>
          matches.small ? (
            <Dialog open={open} onClose={handleClose} fullScreen>
              <DialogTitle id="customized-dialog-title" style={{padding:"0"}} onClick={handleClose}>
                <div className="cdt">
                  <MyButton tip="Back" style={{ color: "#2942ce" }}>
                    <ArrowBackIcon style={{ color: "#2942ce" }} />
                  </MyButton>
                  <Typography variant="h5" style={{ fontWeight: "bold" }}>
                    Thread
                  </Typography>
                </div>
              </DialogTitle>
              <DialogContent dividers>{dialogMarkup}</DialogContent>
            </Dialog>
          ) : (
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
              <DialogTitle
                id="customized-dialog-title"
                onClick={handleClose}
                style={{ padding: "0" }}
              >
               <div className="cdt">
                  <MyButton tip="Back" style={{ color: "#2942ce" }}>
                    <CloseIcon style={{ color: "#2942ce" }} />
                  </MyButton>
                  <Typography variant="h5" style={{ fontWeight: "bold" }}>
                    Thread
                  </Typography>
                </div>
              </DialogTitle>
              <DialogContent dividers>{dialogMarkup}</DialogContent>
            </Dialog>
          )
        }
      </Media>
    </Fragment>
  );
};

PostDialog.propTypes = {
  getPost: PropTypes.func.isRequired,
  postId: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  post: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  post: state.data.post,
  UI: state.UI,
});

const mapActionsToProps = {
  getPost,
  clearErrors,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(PostDialog));
